import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

export enum SnackbarTypeEnum {
  Valid = 'valid',
  Error = 'error',
}

export interface SnackBarData {
  title: string;
  content?: string;
  type: SnackbarTypeEnum;
}

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackBarData) {}
}

@NgModule({
  imports: [CommonModule, MatIconModule],
  declarations: [SnackbarComponent],
  exports: [SnackbarComponent],
})
export class SnackbarModule {}
